import React from 'react'

import type { PageComponents, TitleDescriptionAccordionType } from '@application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'
import { STRAPI_COMPONENT_TYPES } from '@src/Core/Constants/PageConstants'

export const FaqSchema = (props: { pageComponents: Nullable<PageComponents[]> }): Nullable<JSX.Element> => {
    const { pageComponents } = props

    const faq = pageComponents?.find(
        (pageData) => pageData.strapi_component === STRAPI_COMPONENT_TYPES.TITLE_DESCRIPTION_ACCORDION
    )

    if (!faq) {
        return null
    }

    return (
        <script type="application/ld+json">
            {JSON.stringify({
                '@context': 'https://schema.org/',
                '@type': 'FAQPage',
                mainEntity: (faq as TitleDescriptionAccordionType).accordionItems.map((item) => {
                    return {
                        '@type': 'Question',
                        name: item.title,
                        acceptedAnswer: {
                            '@type': 'Answer',
                            text: item.description.data.description,
                        },
                    }
                }),
            })}
        </script>
    )
}
